// extracted by mini-css-extract-plugin
module.exports = {"DraggableCard":"bcr_a"};